/**
 * Outputs duration of given seconds in the format of "Xh YYm, Ym ZZs, or Zs"
 * Examples: "8h 05m", "5m 09s", "3s"
 * Returns "0s" for zero or negative durations
 */
export function formatPreciseDurationCompact(durationInSeconds: number): string {
  if (durationInSeconds <= 0) {
    return "0s";
  }

  const durationInMinutes = Math.floor(durationInSeconds / 60);
  if (durationInMinutes === 0) {
    return `${durationInSeconds}s`;
  }

  const durationInHours = Math.floor(durationInMinutes / 60);
  if (durationInHours === 0) {
    const seconds = durationInSeconds % 60;

    // Ensure seconds are always two digits
    const paddedSeconds = seconds.toString().padStart(2, "0");

    return `${durationInMinutes}m ${paddedSeconds}s`;
  }

  const minutes = durationInMinutes % 60;

  // Ensure minutes are always two digits
  const paddedMinutes = minutes.toString().padStart(2, "0");

  return `${durationInHours}h ${paddedMinutes}m`;
}
